<template>
	<div class="pickList-container">
		<div class="header-box">
			<div class="header-box-left">
				<i class="el-icon-back" @click="goBack"></i>
				<div v-if="params.dateValue !== null && params.dateValue.length !== 0">下单时间：{{date}}</div>
				<div v-if="params.dateValue3 !== null && params.dateValue3.length !== 0">备货时间：{{date3}}</div>
				<div v-if="params.dateValue2 !== null && params.dateValue2.length !== 0">期望到货时间：{{date2}}</div>
				<div>销售店铺：{{shopName}}</div>
				<div>单据状态：{{orderStatus}}</div>
				<div v-if="orderStatus === '待发货'">商品发货状态：{{productStatus}}</div>
				<div v-if="orderStatus === '待接单'">锁定状态：{{lockStatus}}</div>
			</div>
			<div style="width: 200px;display: flex; flex-direction:row-reverse">
				<div class="batch-register-btn"  @click="printClick" >
					<span>打印</span>
				</div>
				<div class="batch-register-btn"  @click="downloadClick" >
					<i class="excel-icon import-excel-icon"/>
					<span>导出</span>
				</div>
			</div>
		</div>
		<div class="table-box" v-if='showType === 0'>
			<el-table
				ref='table'
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				@header-click='headerClick'
				show-summary
				:cell-class-name="addCellClass"
				:summary-method="getSummaries"
				:height="tableHeight">
				<el-table-column
					prop="pro_bcName"
					v-if='showBig'
					label="店铺级大类"
					align='center'
					min-width="120"
					fixed>
				</el-table-column>
				<el-table-column
					prop="pro_scName"
					v-if='showSmall&& bigcategoryview ===1'
					label="店铺级小类"
					align='center'
					min-width="120"
					fixed>
				</el-table-column>
				<el-table-column
					prop="pro_pName"
					label="商品"
					align='center'
					min-width="120"
					fixed>
				</el-table-column>
				<el-table-column
					prop="pro_pUnit"
					label="规格"
					align='center'
					min-width="120"
					fixed>
				</el-table-column>
				<el-table-column
					v-if='showTotal'
					prop="pro_sumTotalCnt"
					label="总计"
					align='center'
					min-width="80"
					fixed>
				</el-table-column>
				<el-table-column v-for='(item,index) in titleList' align='center' :key='index' :label="item.name">
					<el-table-column v-for='(item1,index1) in item.arr' :prop="item1.key" align='center' :key='index1' :label="item1.name">
						<el-table-column
							v-for='(item2,index2) in item1.arr' :key='index2'
							:render-header="item2.orderSource === 1 ? renderHeader : renderHeader1"
							:prop="item2.key"
							:label="item2.name"
							align='center'
							:min-width='item2.width'
						>
						</el-table-column>
					</el-table-column>
				</el-table-column>
			</el-table>
		</div>
		<div class="table-box" v-if='showType === 1'>
			<el-table
				v-if='showBig && showSmall && bigcategoryview === 1'
				ref='table'
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				show-summary
				:summary-method="getSummaries1"
				@header-click='headerClick'
				:cell-class-name="addCellClass"
				:height="tableHeight">
				<el-table-column label="店铺级大类" align='center' min-width="240" fixed="left">
					<el-table-column label="店铺级小类" align='center' min-width="240">
						<el-table-column
							prop="cus_cusName"
							label="客户"
							align='center'
							min-width="120">
						</el-table-column>
						<el-table-column
							v-if='showTotal'
							prop="cus_sumTotalCnt"
							label="总计"
							align='center'
							min-width="120">
						</el-table-column>
					</el-table-column>
				</el-table-column>
				<el-table-column v-for='(item,index) in proList' align='center' :key='index' :label="item.pro_bcName">
					<el-table-column align='center' :label="item.pro_scName">
						<el-table-column align='center' :label="item.pro_pName">
							<el-table-column
								v-for='(item1,index1) in item.arr' :key='index1'
								:prop="item1.key"
								:render-header="item1.orderSource === 1 ? renderHeader : renderHeader1"
								:label="item1.name"
								align='center'
								:min-width='item1.width'
							>
							</el-table-column>
						</el-table-column>
					</el-table-column>
				</el-table-column>
			</el-table>
			<el-table
				v-if='!showBig && showSmall && bigcategoryview === 1'
				ref='table'
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				@header-click='headerClick'
				show-summary
				:summary-method="getSummaries1"
				:cell-class-name="addCellClass"
				:height="tableHeight">
				<el-table-column label="店铺级小类" align='center' min-width="240" fixed="left">
					<el-table-column
						prop="cus_cusName"
						label="客户"
						align='center'
						min-width="120">
					</el-table-column>
					<el-table-column
						v-if='showTotal'
						prop="cus_sumTotalCnt"
						label="总计"
						align='center'
						min-width="120">
					</el-table-column>
				</el-table-column>
				<el-table-column v-for='(item,index) in proList' align='center' :key='index' :label="item.pro_scName">
					<el-table-column align='center' :label="item.pro_pName">
						<el-table-column
							v-for='(item1,index1) in item.arr' :key='index1'
							:prop="item1.key"
							:render-header="item1.orderSource === 1 ? renderHeader : renderHeader1"
							:label="item1.name"
							align='center'
							:min-width='item1.width'
						>
						</el-table-column>
					</el-table-column>
				</el-table-column>
			</el-table>
			<el-table
				v-if='showBig && !(showSmall && bigcategoryview === 1)'
				ref='table'
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				show-summary
				@header-click='headerClick'
				:summary-method="getSummaries1"
				:cell-class-name="addCellClass"
				:height="tableHeight">
				<el-table-column label="店铺级大类" align='center' min-width="240" fixed="left">
					<el-table-column
						prop="cus_cusName"
						label="客户"
						align='center'
						min-width="120">
					</el-table-column>
					<el-table-column
						v-if='showTotal'
						prop="cus_sumTotalCnt"
						label="总计"
						align='center'
						min-width="120">
					</el-table-column>
				</el-table-column>
				<el-table-column v-for='(item,index) in proList' align='center' :key='index' :label="item.pro_bcName">
					<el-table-column align='center' :label="item.pro_pName">
						<el-table-column
							v-for='(item1,index1) in item.arr' :key='index1'
							:prop="item1.key"
							:label="item1.name"
							:render-header="item1.orderSource === 1 ? renderHeader : renderHeader1"
							align='center'
							:min-width='item1.width'
						>
						</el-table-column>
					</el-table-column>
				</el-table-column>
			</el-table>
			<el-table
				v-if='!showBig && !(showSmall && bigcategoryview === 1)'
				ref='table'
				class="grid-content"
				:data="tableData"
				border
				size='mini'
				@header-click='headerClick'
				show-summary
				:summary-method="getSummaries1"
				:cell-class-name="addCellClass"
				:height="tableHeight">
				<el-table-column
					prop="cus_cusName"
					label="客户"
					align='center'
					min-width="120"
					fixed="left">
				</el-table-column>
				<el-table-column
					v-if='showTotal'
					prop="cus_sumTotalCnt"
					label="总计"
					align='center'
					min-width="120"
					fixed="left">
				</el-table-column>
				<el-table-column v-for='(item,index) in proList' align='center' :key='index' :label="item.pro_pName">
					<el-table-column
						v-for='(item1,index1) in item.arr' :key='index1'
						:prop="item1.key"
						:render-header="item1.orderSource === 1 ? renderHeader : renderHeader1"
						:label="item1.name"
						align='center'
						:min-width='item1.width'
					>
					</el-table-column>
				</el-table-column>
			</el-table>
		</div>
	</div>
</template>

<script>
export default {
	name: 'categoryLists',
	data () {
		return {
			showType: null,
			showTotal: false,
			showLineTotal: false,
			showSmallTotal: false,
			showOrder: false,
			bigcategoryview: null,
			showBig: true,
			showSmall: true,
			date: '',
			date2: '',
			date3: '',
			shopName: '',
			productStatus: '',
			titleList: [],
			proList: [],
			tableData: [],
			tableHeight: '100%',
			params: {},
			orderStatus: '',
			lockStatus: ''
		}
	},
	created () {
		var data = window.sessionStorage.getItem('pickListData')
		var params = JSON.parse(data)
		this.params = params
		this.init(params)
	},
	methods: {
		printClick () {
			// this.$fxGoBlank('/pickListTablePrint', this.$router)
			this.$router.push('/main/pickListTablePrint')
		},
		headerClick (column, event) {
			// debugger
			let url = column.label
			let oInput = document.createElement('input')
			oInput.value = url
			document.body.appendChild(oInput)
			oInput.select() // 选择对象;
			document.execCommand('Copy')
			this.$message({
				message: '复制成功',
				type: 'success'
			})
			oInput.remove()
		},
		renderHeader1 (h, { column }) {
			return h(
				'div',
				[
					h('span', column.label)
				]
			)
		},
		renderHeader (h, { column }) {
			return h(
				'div', {
					class: 'header-div'
				},
				[
					h('span', column.label),
					h('div', {
						class: 'dai-icon'
					})
				]
			)
		},
		downloadClick () {
			const req = new XMLHttpRequest()
			let _this = this
			req.open('POST', `${this.$fxBaseApi.newExportUrl}/order/pickGoodsListExport`, true)
			req.responseType = 'blob'
			req.setRequestHeader('Content-Type', 'application/json')
			req.setRequestHeader('pname', 'bc2ff5388144d30e137b28acafd39795')
			req.setRequestHeader('shiroSession', window.sessionStorage.getItem('shiroSession'))
			req.onload = function () {
				const data = req.response
				const blob = new Blob([data])
				const blobUrl = window.URL.createObjectURL(blob)
				_this.download(blobUrl)
			}
			let params = this.params
			req.send(JSON.stringify(params))
		},
		download (blobUrl) {
			const a = document.createElement('a')
			a.style.display = 'none'
			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			var day = date.getDate()
			var name = ''
			if (this.showType === 0) {
				name = '拣货清单商品纵序(' + year + '-' + month + '-' + day + ').xls'
			} else {
				name = '拣货清单商品横序(' + year + '-' + month + '-' + day + ').xls'
			}
			a.download = name
			a.href = blobUrl
			a.click()
		},
		getSummaries1 (param) {
			const { columns, data } = param
			const sums = []
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计'
					return
				}
				const values = data.map(item => Number(item[column.property]))
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						curr *= 10000
						const value = Number(curr)
						if (!isNaN(value)) {
							return prev + curr
						} else {
							return prev
						}
					}, 0)
					sums[index] /= 10000
					if (this.showLineTotal) {
						if (column.label === '小计' || column.label === '总计') {
							sums[index] = sums[index] / 2
						}
					}
				} else {
					sums[index] = ''
				}
			})
			return sums
		},
		getSummaries (param) {
			const { columns, data } = param
			const sums = []
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计'
					return
				}
				if (this.showBig && this.showSmall && this.bigcategoryview === 1) {
					if (index === 1 || index === 2 || index === 3) {
						sums[index] = ''
						return
					}
				} else if (this.showBig || (this.showSmall && this.bigcategoryview === 1)) {
					if (index === 1 || index === 2) {
						sums[index] = ''
						return
					}
				} else {
					if (index === 1) {
						sums[index] = ''
						return
					}
				}
				const values = data.map(item => Number(item[column.property]))
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						curr *= 10000
						const value = Number(curr)
						if (!isNaN(value)) {
							return prev + curr
						} else {
							return prev
						}
					}, 0)
					sums[index] /= 10000
					// sums[index] += ' 元'
				} else {
					sums[index] = ''
				}
			})
			return sums
		},
		initTitleData (data) {
			var arr = []
			for (var i = 0; i < data.length; i++) {
				var row = {
					name: data[i].orderLine,
					arr: []
				}
				if (this.showLineTotal) {
					row.arr.push({
						name: '线路小计',
						key: data[i].lineId + '-Total',
						width: '80'
					})
				}
				if (this.showSmallTotal || this.showOrder) {
					for (var z = 0; z < data[i].cus.length; z++) {
						var cusRow = {
							name: data[i].cus[z].cusName,
							arr: []
						}
						if (this.showSmallTotal) {
							cusRow.arr.push({
								name: '小计',
								key: data[i].lineId + '-' + data[i].cus[z].cusSyscodeId + '-total',
								width: '80'
							})
						}
						if (this.showOrder) {
							for (var j = 0; j < data[i].cus[z].order.length; j++) {
								var orderRow = {
									name: data[i].cus[z].order[j].orderNumber,
									orderSource: data[i].cus[z].order[j].orderSource,
									key: data[i].lineId + '-' + data[i].cus[z].cusSyscodeId + '-' + data[i].cus[z].order[j].orderNumber,
									width: '140'
								}
								cusRow.arr.push(orderRow)
							}
						}
						row.arr.push(cusRow)
					}
				}
				arr.push(row)
			}
			this.titleList = arr
		},
		initData (data) {
			var dataArr = []
			for (var i = 0; i < data.length; i++) {
				var dataRow = {
					pro_bcName: data[i].pro_bcName,
					pro_scName: data[i].pro_scName,
					pro_sumTotalCnt: data[i].pro_sumTotalCnt,
					pro_pUnit: data[i].pro_pUnit,
					pro_pName: data[i].pro_pName
				}
				for (var j = 0; j < data[i].line.length; j++) {
					dataRow[data[i].line[j].lineId + '-Total'] = data[i].line[j].totalCnt
					for (var z = 0; z < data[i].line[j].cus.length; z++) {
						dataRow[data[i].line[j].lineId + '-' + data[i].line[j].cus[z].cusSyscodeId + '-total'] = data[i].line[j].cus[z].totalCnt === 0 ? '' : data[i].line[j].cus[z].totalCnt
						for (var k = 0; k < data[i].line[j].cus[z].order.length; k++) {
							dataRow[data[i].line[j].lineId + '-' + data[i].line[j].cus[z].cusSyscodeId + '-' + data[i].line[j].cus[z].order[k].orderNumber] = data[i].line[j].cus[z].order[k].sendQuantity === 0 ? '' : data[i].line[j].cus[z].order[k].sendQuantity
						}
					}
				}
				dataArr.push(dataRow)
			}
			this.tableData = dataArr
		},
		init (data) {
			this.date = data.beginDate + ' 至 ' + data.endDate
			this.date2 = data.wantArrivalBeginDate + ' 至 ' + data.wantArrivalEndDate
			this.date3 = data.prepareBeginDate + ' 至 ' + data.prepareEndDate
			this.shopName = window.localStorage.getItem('shopName')
			this.bigcategoryview = data.bigcategoryview
			this.showType = data.showType
			this.showBig = data.showBig === 1
			this.showSmall = data.showSmall === 1
			var pStatus = data.pStatus + ''
			switch (pStatus) {
			case '-1':
				this.productStatus = '全部'
				break
			case '0':
				this.productStatus = '未发货'
				break
			case '1':
				this.productStatus = '已发货'
				break
			}
			var orderStatus = data.orderStatus + ''
			switch (orderStatus) {
			case '1':
				this.orderStatus = '待接单'
				break
			case '2':
				this.orderStatus = '待发货'
				break
			case '3':
				this.orderStatus = '待收货'
				break
			case '4':
				this.orderStatus = '已完成'
				break
			}
			var lockStatus = data.lockStatus + ''
			switch (lockStatus) {
			case '-1':
				this.lockStatus = '全部'
				break
			case '0':
				this.lockStatus = '否'
				break
			case '1':
				this.lockStatus = '是'
				break
			}
			var list = data.showContent
			for (var i = 0; i < list.length; i++) {
				if (list[i] === 0) {
					this.showTotal = true
				}
				if (list[i] === 1) {
					this.showSmallTotal = true
				}
				if (list[i] === 2) {
					this.showOrder = true
				}
				if (list[i] === 3) {
					this.showLineTotal = true
				}
			}
			this.getList()
		},
		goBack () {
			this.$router.push('/main/pickingList')
		},
		getList () {
			var data = window.sessionStorage.getItem('pickListData')
			var params = JSON.parse(data)
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/order/pickGoodsList`,
				data: params
			}).then(res => {
				if (res.result) {
					if (this.showType === 0) {
						this.initTitleData(res.data.lineInfo)
						this.initData(res.data.proInfo)
					} else {
						if (this.showSmallTotal || this.showOrder) {
							this.initProData(res.data.proInfo)
						}
						this.initData1(res.data.lineInfo)
					}
				} else {
					this.$message.error(res.msg)
				}
			})
		},
		initProData (data) {
			var arr = []
			for (var i = 0; i < data.length; i++) {
				var row = {
					pro_pName: data[i].cus_pro_pName,
					pro_bcName: data[i].cus_pro_bcName,
					pro_scName: data[i].cus_pro_scName,
					arr: []
				}
				if (this.showSmallTotal) {
					row.arr.push({
						name: '小计',
						key: data[i].cus_pro_pName + '-total',
						width: '80'
					})
				}
				if (this.showOrder) {
					for (var j = 0; j < data[i].cus_pro_order.length; j++) {
						var orderRow = {
							name: data[i].cus_pro_order[j].orderNumber,
							orderSource: data[i].cus_pro_order[j].orderSource,
							key: data[i].cus_pro_pName + '-' + data[i].cus_pro_order[j].orderNumber,
							width: '140'
						}
						row.arr.push(orderRow)
					}
				}
				arr.push(row)
			}
			this.proList = arr
		},
		initData1 (data) {
			var dataArr = []
			for (var i = 0; i < data.length; i++) {
				for (var k = 0; k < data[i].cus.length; k++) {
					var dataRow = {
						cus_cusName: data[i].line_orderLine + ' - ' + data[i].cus[k].cusName,
						cus_sumTotalCnt: data[i].cus[k].cus_sumTotalCnt
					}
					for (var j = 0; j < data[i].cus[k].pro.length; j++) {
						for (var z = 0; z < data[i].cus[k].pro[j].order.length; z++) {
							dataRow[data[i].cus[k].pro[j].pName + '-total'] = data[i].cus[k].pro[j].totalCnt === 0 ? '' : data[i].cus[k].pro[j].totalCnt
							dataRow[data[i].cus[k].pro[j].pName + '-' + data[i].cus[k].pro[j].order[z].orderNumber] = data[i].cus[k].pro[j].order[z].sendQuantity === 0 ? '' : data[i].cus[k].pro[j].order[z].sendQuantity
						}
					}
					dataArr.push(dataRow)
				}
				if (this.showLineTotal) {
					var obj = data[i].pro
					var lineRow = {
						cus_cusName: data[i].line_orderLine + '小计',
						cus_sumTotalCnt: data[i].totalCnt
					}
					Object.keys(obj).forEach(function (key) {
						lineRow[key + '-total'] = obj[key]
					})
					dataArr.push(lineRow)
				}
			}
			this.tableData = dataArr
		},
		addCellClass (row) {
			if (row.column.property.indexOf('total') !== -1) {
				return 'cellClass'
			}
			if (row.column.property === 'pro_sumTotalCnt' || row.column.property === 'cus_sumTotalCnt') {
				return 'cellClass1'
			}
		}
	}
}
</script>

<style lang="stylus" scoped>
.pickList-container {
	display: flex;
	min-width: 730px;
	width: 100%;
	flex-direction: column;
	height: 100%;
	min-height: 0;
	.batch-register-btn{
		cursor :pointer;
		color: var(--fx-primary-color);
		font-size: 12px;
		margin-left: 15px;
		display: flex;
		align-items:center;
		width: 50px;
		height: 40px;
		// position: absolute;
		// left: 10px;
	}
	.excel-icon {
		display inline-block
		height 20px
		width 20px
		background-repeat no-repeat
		background-position center
		vertical-align: sub;
		&.import-excel-icon {
			background-image: url('~images/icon/import-excel-icon.png')
		}
		&.export-excel-icon {
			background-image: url('~images/icon/export-excel-icon.png')
		}
	}
	.header-box{
		box-sizing :border-box;
		width :100%;
		height :50px;
		border-bottom :1px solid #DCE2FD;
		display :flex;
		flex-direction :row;
		align-items:center;
		justify-content :space-between;
		color :#333;
		font-size :14px;
		.header-box-left{
			display :flex;
			flex-direction :row;
			align-items:center;
			div{
				margin-right :40px;
			}
			.el-icon-back{
				border-radius: 50%;
				cursor: pointer;
				background: #9da6af;
				padding: 3px;
				margin-right: 5px;
				&:before {
					content: "\E6EA";
					color: #fff;
					font-weight: bold;
				}
			}
		}
	}
	.table-box {
		flex: 1
		padding-bottom: 10px
		margin-top :20px;
		overflow-y: auto;
		.grid-content {
			height 100%
		}
	}
}
</style>
<style lang="stylus">
.cellClass1{
	background-color :#EDF56A;
}
.cellClass {
	background-color :#C2F8AC;
}
.el-table{
	overflow:visible !important;
}
.header-div{
	display :flex;
	justify-content:center;
	align-items:center
}
.dai-icon {
		margin-left :5px;
		background: url('~images/icon/dai-icon.png') no-repeat;
		width: 16px;
		height: 16px;
		min-width: 16px;
		display :block
	}
.el-table__fixed-left{
  height: 100% !important;
}
</style>
